import React, { useState, useEffect } from "react";
import { db } from "../../../../assets/firebase/firebaseconfig";
import { ref, remove, update, onValue, push } from "firebase/database";
import "./styles.css";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const ProductManager = () => {
  const [quillKey, setQuillKey] = useState(0);
  const [editingProduct, setEditingProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    brand: "",
    category: "",
    description: "",

  });
  const [newEditFile, setNewEditFile] = useState(null);
  const [updatingMedia, setUpdatingMedia] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  const CLOUD_NAME = "dseiy70jw";
  const UPLOAD_PRESET = "habakome";

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };

  useEffect(() => {
    const productRef = ref(db, "products");
    onValue(productRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
          
        }));
        setProducts(list);
      } else {
        setProducts([]);
      }
    });
  }, []);

  const openEditModal = (product) => {
    setEditingProduct(product);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!editingProduct?.id) return alert("ID không hợp lệ!");
    setUpdatingMedia(true);
    try {
      let finalMediaUrl = editingProduct.mediaUrl;
      let finalFileType = editingProduct.fileType;

      if (newEditFile) {
        const data = new FormData();
        data.append("file", newEditFile);
        data.append("upload_preset", UPLOAD_PRESET);
        const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/upload`, {
          method: "POST",
          body: data,
        });
        const fileData = await res.json();
        if (fileData.secure_url) {
          finalMediaUrl = fileData.secure_url;
          finalFileType = fileData.resource_type;
        }
      }

      const productRef = ref(db, `products/${editingProduct.id}`);
      const updatedData = {
        name: editingProduct.name || "",
        brand: editingProduct.brand || "",
        category: editingProduct.category || "",
        description: editingProduct.description || "",
        mediaUrl: finalMediaUrl,
        fileType: finalFileType,
        updatedAt: Date.now(),
      };

      await update(productRef, updatedData);
      alert("Cập nhật thành công!");
      setEditingProduct(null);
      setNewEditFile(null);
    } catch (error) {
      alert("Lỗi: " + error.message);
    } finally {
      setUpdatingMedia(false);
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!file) return alert("Vui lòng chọn ảnh!");

    setLoading(true);
    try {
      const data = new FormData();
      data.append("file", file);
      data.append("upload_preset", UPLOAD_PRESET);
      const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/upload`, {
        method: "POST",
        body: data,
      });
      const fileData = await res.json();

      if (!fileData.secure_url) throw new Error("Lỗi Cloudinary");

      const newProduct = {
        ...formData,
        mediaUrl: fileData.secure_url,
        fileType: fileData.resource_type,
        createdAt: Date.now(),
      };

      await push(ref(db, "products"), newProduct);
      alert("Thêm sản phẩm thành công!");
      setFormData({ name: "", brand: "", category: "", description: "" });
      setFile(null);
      setShowAddModal(false);
      setQuillKey((prev) => prev + 1);
    } catch (error) {
      alert("Lỗi: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (productId) => {
    if (window.confirm("Bạn có chắc muốn xóa sản phẩm này?")) {
      try {
        await remove(ref(db, `products/${productId}`));
        alert("Xóa thành công!");
      } catch (error) {
        alert("Lỗi khi xóa!");
      }
    }
  };

  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toLowerCase();
  };

  const filteredProducts = products
    .filter((item) => {
      if (!searchTerm) return true;
      const nameRaw = item.name ? item.name.toLowerCase() : "";
      const searchRaw = searchTerm.toLowerCase();
      return nameRaw.includes(searchRaw) || removeAccents(nameRaw).includes(removeAccents(searchRaw));
    })
    .sort((a, b) => {
      const nameA = a.name ? a.name.toLowerCase() : "";
      const nameB = b.name ? b.name.toLowerCase() : "";
      return sortOrder === "asc" ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
    });

  return (
    <div className="product-manager">
      <div className="add-box">
        <div className="admin-header-actions" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', gap: '15px', flexWrap: 'wrap' }}>
          <div className="filter-bar">
            <input
              type="text"
              placeholder="🔍 Tìm kiếm sản phẩm..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
              <option value="asc">Tên A → Z</option>
              <option value="desc">Tên Z → A</option>
            </select>
          </div>
          <button className="btn-add-main" onClick={() => setShowAddModal(true)}>
            + Thêm sản phẩm mới
          </button>
        </div>

        {showAddModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h3>THÊM SẢN PHẨM MỚI</h3>
                <button className="close-btn" onClick={() => setShowAddModal(false)}>×</button>
              </div>
              <form onSubmit={handleSubmit} className="admin-form-grid">
                <div style={{ gridColumn: "span 2" }}>
                  <input type="text" placeholder="Tên sản phẩm" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
                </div>
                <input type="text" placeholder="Thương hiệu" value={formData.brand} onChange={(e) => setFormData({ ...formData, brand: e.target.value })} />
                <input type="text" placeholder="Danh mục" value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })} />
                <div className="form-group" style={{ gridColumn: "span 2" }}>
                  <label>Mô tả:</label>
                  <ReactQuill key={quillKey} theme="snow" value={formData.description} onChange={(val) => setFormData({ ...formData, description: val })} modules={modules} />
                </div>
                <div className="form-group" style={{ gridColumn: "span 2" }}>
                  <label>Chọn Media:</label>
                  <input type="file" onChange={(e) => setFile(e.target.files[0])} />
                </div>
                <button type="submit" disabled={loading} className="btn-save">
                  {loading ? "Đang tải..." : "LƯU SẢN PHẨM"}
                </button>
              </form>
            </div>
          </div>
        )}

        {editingProduct && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h3>CHỈNH SỬA SẢN PHẨM</h3>
                <button className="close-btn" onClick={() => setEditingProduct(null)}>×</button>
              </div>
              <form onSubmit={handleUpdate} className="admin-form-grid">
                <div style={{ gridColumn: "span 2" }}>
                  <input type="text" value={editingProduct.name} onChange={(e) => setEditingProduct({ ...editingProduct, name: e.target.value })} />
                </div>
                <input type="text" value={editingProduct.brand} onChange={(e) => setEditingProduct({ ...editingProduct, brand: e.target.value })} />
                <input type="text" value={editingProduct.category} onChange={(e) => setEditingProduct({ ...editingProduct, category: e.target.value })} />
                <div className="form-group" style={{ gridColumn: "span 2" }}>
                  <label>Thay đổi Media:</label>
                  <input type="file" onChange={(e) => setNewEditFile(e.target.files[0])} />
                </div>
                <div className="form-group" style={{ gridColumn: "span 2" }}>
                  <label>Mô tả:</label>
                  <ReactQuill theme="snow" value={editingProduct.description} onChange={(val) => setEditingProduct({ ...editingProduct, description: val })} modules={modules} />
                </div>
                <button type="submit" disabled={updatingMedia} className="btn-save">
                  {updatingMedia ? "Đang lưu..." : "LƯU THAY ĐỔI"}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>

      <div className="list-box">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Media</th>
              <th>Sản phẩm</th>
              <th>Danh mục</th>
              <th>Mô tả</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((item) => (
              <tr key={item.id}>
                <td>
                  {item.fileType === "video" ? 
                    <video src={item.mediaUrl} className="admin-thumb" muted /> : 
                    <img src={item.mediaUrl} className="admin-thumb" alt="" />
                  }
                </td>
                <td>
                  <b>{item.name}</b><br />
                  <span className="brand-badge">{item.brand}</span>
                </td>
                <td>{item.category}</td>
                <td className="text-truncate">
                  <div className="ql-editor" dangerouslySetInnerHTML={{ __html: item.description }} style={{ maxHeight: '50px', overflow: 'hidden' }} />
                </td>
                <td>
                  <button className="btn-edit" onClick={() => openEditModal(item)}>✏️</button>
                  <button className="btn-del" onClick={() => handleDelete(item.id)}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductManager;